export default class ObjectUtil {
  // Get key of an object item by it's value
  static getKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key] === value);
  }
}
